import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';

@Component({
  selector: 'system-notifications',
  templateUrl: './system-notifications.component.html',
  styleUrls: ['./system-notifications.component.scss']
})
export class SystemNotificationsComponent implements OnInit {

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
  }
}
